module.exports = __webpack_public_path__ + "static/media/friends.a437e299.svg";